export const jaChannels = {
  ChannelsTextInputNameSelectChannelsAddLabels: '名前を入力し、チャンネルを選択、ラベルを追加します。',
};
